/* tslint:disable */
/* eslint-disable */
/**
 * driverPortal fleet-registration api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 *
 * //!!!! WARNING !!!!!!!!
 * //This is an auto generated file.
 * //Changes to this code will be lost if the code is regenerated.
 */
import type { Countries } from './Countries';
import type { FormCountryMinimal } from './FormCountryMinimal';

export interface GetDriverRegistrationMinimalFormDataResponse {
    cities_by_countries: Array<FormCountryMinimal>;
    exclude_term_consent_in_cities: Array<number>;
    /** Can be removed after task {@link https://taxify.atlassian.net/browse/WEB-8278 WEB-8278} is completed */
    terms_consent_required: Array<Countries>;
}
